import React, { Children, useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';

import Layout from '../../Layout/PrivateLayout';
import * as General from '../General/General';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import * as BiIcon from "react-icons/bi";



const UserConfigIndex = () => {

    //#region Const
    const toaster = rsuite.useToaster();
    let navigate = useNavigate();

    const [List, setList] = useState([]);
    // const [Type, setType] = useState(-1);

    //#endregion



    //#region Methods



    const GetAll = () => {
        var myHeaders = new Headers()
        myHeaders.append("ApiKey", General.APIKey())

        var requestOptions = {
            headers: myHeaders,
            method: 'Get',
            credentials: 'include'
        }
        // trackPromise(
        fetch(General.ApiRoute() + '/Config/GetUserConfigForUpdate', requestOptions)
            .then(res => res.json())
            .then(result => {
                console.dir("123")
                var tmp = []
                console.dir(result)

                for (var i = 0; i < result.length; i++) {
                    tmp.push({
                        key: result[i].key,
                        id: result[i].id,
                        value: result[i].value,
                        type: result[i].type,
                        typeComment: result[i].typeComment,
                        configs: result[i].configs,
                    })
                }
                setList(tmp)
                console.dir(tmp)
                GetUserConfig();
            })
        // )
    }


    const GetUserConfig = () => {
        var myHeaders = new Headers()
        myHeaders.append("ApiKey", General.APIKey())

        var requestOptions = {
            headers: myHeaders,
            method: 'Get',
            credentials: 'include'
        }
        // trackPromise(
        fetch(General.ApiRoute() + '/Common/GetUserConfig', requestOptions)
            .then(res => res.json())
            .then(result => {
                for (var i = 0; i < result.length; i++) {
                    localStorage.removeItem(result[i].key_ShortCut)
                    localStorage.setItem(result[i].key_ShortCut, result[i].value)
                }
            })
        // )
    }


    const ChangeValue = (value, type, id, valueType) => {
        console.dir(value);
        var index = List.findIndex(x => x.type == type);
        if (index != -1) {
            var itemIndex = List[index].configs.findIndex(x => x.id = id);
            var RequestOptions = {
                data: {
                    "type": List[index].type,
                    "value": valueType == "Checkbox" && value == false ? "0" : valueType == "Checkbox" && value == true ? "1" : value,
                    "id": id,
                    "key": List[index].configs[itemIndex].key,
                },
                url: General.ApiRoute() + "/Config/UpdateUserConfig",
                method: "post",
                withCredentials: true,

                headers: {
                    'ApiKey': General.APIKey(),
                    'Content-Type': 'application/json'
                }
            }
            trackPromise(
                axios(RequestOptions)
                    .then(function (result) {

                        if (result.data.includes("OK")) {
                            toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است")), 'topCenter')
                            GetAll();
                        }
                        else {
                            toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                        }

                    }).catch((error) => {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                    })
            )
        }
    }

    const ChangeText = (value, type, id) => {
        var temp = [...List]
        var index = temp.findIndex(x => x.type == type);
        if (index != -1) {
            var itemIndex = temp[index].configs.findIndex(x => x.id == id);
            temp[index].configs[itemIndex].value = value;
            setList(temp);

        }
    }

    const CheckPermission = () => {

        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 31);
        myHeaders.append("Operation", 0);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        navigate("/AccessDenied");
                    }
                    else {
                        GetAll();
                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }

    useEffect(() => {
        CheckPermission();
        document.title = " تنظیمات سیستم";
    }, [])
    //#endregion



    return (

        <Layout title=" تنظیمات سیستم">
            <div className="h-100 p-1"  >
                <rsuite.Panel className="bg-white ">

                    <rsuite.Row className="p-1 mb-5 pb-5" >
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className='mt-3'>
                            <rsuite.Tabs defaultActiveKey='1' appearance="subtle">
                                {List.map(config => (
                                    <rsuite.Tabs.Tab eventKey={config.type} title={config.typeComment}>
                                        {config.configs.map(inner =>
                                            <rsuite.Row className='p-1'>
                                                {inner.valueType == "Checkbox" ?
                                                    <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                        <rsuite.Checkbox onChange={(e, checked) => ChangeValue(checked, config.type, inner.id, inner.valueType)} checked={inner.value == "0" ? false : true} value={inner.value == "0" ? false : true} /> &nbsp;  <label>{inner.key}</label>
                                                    </rsuite.Col>
                                                    :
                                                    inner.valueType == "Radio" ?
                                                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                            <rsuite.Checkbox onChange={(e, checked) => ChangeValue(checked, config.type, inner.id, inner.valueType)} checked={inner.value == "0" ? false : true} value={inner.value == "0" ? false : true} /> &nbsp;  <label>{inner.key}</label>
                                                        </rsuite.Col>
                                                        :
                                                        inner.valueType == "ComboBox" ?
                                                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                <label>{inner.key}</label>
                                                                <select className="rs-input" onChange={(e) => ChangeValue(e.target.value, config.type, inner.id, inner.valueType)} value={inner.value}>
                                                                    {inner.selectValue.split("/").map(innerselect =>
                                                                        <option value={innerselect}>{innerselect}  </option>
                                                                    )}
                                                                </select>
                                                            </rsuite.Col> :
                                                            inner.valueType == "Textarea" ?
                                                                <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                    <label>{inner.key}</label>
                                                                    <rsuite.InputGroup className="mt-2" inside >
                                                                        <rsuite.Input as="textarea" rows={6} onChange={(e) => ChangeText(e, config.type, inner.id)} value={inner.value} placeholder=" متن خود را وارد کنید"></rsuite.Input>
                                                                        <rsuite.InputGroup.Addon>
                                                                            <rsuite.Button className="h-100p" color="green"
                                                                                onClick={() => ChangeValue(inner.value, config.type, inner.id, inner.valueType)}
                                                                                appearance="primary" block>  ثبت    </rsuite.Button>
                                                                        </rsuite.InputGroup.Addon>
                                                                    </rsuite.InputGroup>

                                                                </rsuite.Col>
                                                                : // Text
                                                                <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                    <rsuite.Checkbox onChange={(e, checked) => ChangeValue(checked, config.type, inner.id, inner.valueType)} checked={inner.value == "0" ? false : true} value={inner.value == "0" ? false : true} /> &nbsp;  <label>{inner.key}</label>
                                                                </rsuite.Col>
                                                }
                                            </rsuite.Row>)}
                                    </rsuite.Tabs.Tab>
                                ))}
                            </rsuite.Tabs>
                        </rsuite.Col>
                    </rsuite.Row>

                </rsuite.Panel >
            </div >
        </Layout >
    )
}

export default UserConfigIndex;